class WorkPlanSrv {

	constructor ($resource, SERVICE_URL_CONSTANT, GlobalConfig) {
		var addOtherActivityAM = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addOtherActivityAM', {}, {
			add: {
				method: 'POST',
			},
		})

		var getOtherActivityItemAM = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getOtherActivityItemAM', {}, {
			get: {
				method: 'POST',
			},
		})

		var disableActivity = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/disableActivity', {}, {
			delete: {
				method: 'POST',
			},
		})

		// OTHER Services
		var getActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/', {}, {
			getList: {
				method: 'POST',
			},
		})

		var addActivityCommunity = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addActivityCommunity', {}, {
			add: {
				method: 'POST',
			},
		})

		var getActivityDetailTeachingStaff = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getActivityDetailTeachingStaff', {}, {
			get: {
				method: 'POST',
			},
		})

		var getActivitiesCombo = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getTypeActivities/combo/:listTypeId/:listId', {}, {
			getList: {
				method: 'GET',
			},
		})

		var addActivityItem = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addOtherActivityItem', {}, {
			add: {
				method: 'POST',
			},
		})

		var getActivityCommitteeByActivity = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getActivityCommitteeByActivity', {}, {
			get: {
				method: 'POST',
			},
		})

		var addActivityCommittee = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addActivityCommittee', {}, {
			add: {
				method: 'POST',
			},
		})

		var getListOtherActivityItemAM = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListOtherActivityItemAM', {}, {
			get: {
				method: 'POST',
			},
		})

		var addActivityPlanningTeacher = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addActivityPlanningTeacher', {}, {
			save: {
				method: 'POST',
			},
		})

		var getDetailAsignaturePlanning = $resource(SERVICE_URL_CONSTANT.rosario + '/subject/getDetailAsignaturePlanning', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getWorkplanByEvaluatorAndStage = $resource(SERVICE_URL_CONSTANT.rosario + '/reviewer/getWorkplanByEvaluatorAndStage', {}, {
			getList: {
				method: 'POST',
			},
		})

		var updateActivityItem = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/updateOtherActivityItem', {}, {
			update: {
				method: 'POST',
			},
		})

		var deleteActivityItem = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/deleteOtherActivityItem', {}, {
			delete: {
				method: 'POST',
			},
		})

		var getActivityPlanningTeacher = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getActivityPlanningTeacher', {}, {
			get: {
				method: 'POST',
			},
		})

		var getPreviusPlanning = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getPreviousActivitiesPlanning', {}, {
			get: {
				method: 'POST',
			},
		})

		var getDataFormCommittee = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormCommittee', {}, {
			get: {
				method: 'POST',
			},
		})

		var getActivityItem = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/:otherActivityCode', {}, {
			get: {
				method: 'GET',
			},
		})

		var getAsignaturesAssigned = $resource(SERVICE_URL_CONSTANT.rosario + '/subject/getAsignaturesAssigned', {}, {
			getList: {
				method: 'POST',
			},
		})
		var getPeriodicity = $resource(SERVICE_URL_CONSTANT.rosario + '/periodicity', {}, {
			get: {
				method: 'GET',
			},
		})

		// SCHEDULE SERVICES
		var getSchedules = $resource(SERVICE_URL_CONSTANT.rosario + '/calendar/getActivityCalendar', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getSchedulesReject = $resource(SERVICE_URL_CONSTANT.rosario + '/calendar/getActivityCalendarReviewedReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		var addSchedule = $resource(SERVICE_URL_CONSTANT.rosario + '/calendar/addActivityCalendar', {}, {
			add: {
				method: 'POST',
			},
		})

		var disableSchedule = $resource(SERVICE_URL_CONSTANT.rosario + '/calendar/deleteActivityCalendar', {}, {
			disable: {
				method: 'POST',
			},
		})

		var getScheduleById = $resource(SERVICE_URL_CONSTANT.rosario + '/calendar/getActivityCalendarById/:calendarId', {}, {
			get: {
				method: 'GET',
			},
		})

		var updateSchedule = $resource(SERVICE_URL_CONSTANT.rosario + '/calendar/addActivityCalendar', {}, {
			update: {
				method: 'POST',
			},
		})

		var getDataForSchedule = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormAttentionStudents', {}, {
			get: {
				method: 'POST',
			},
		})

		var getElementsRightBar = $resource(SERVICE_URL_CONSTANT.rosario + '/general/getWorkPlanGeneral', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getIndicatorBySubmodule = $resource(SERVICE_URL_CONSTANT.rosario + '/general/getIndicatorBySubmodule', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getAssignatureWithoutActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getAssignatureWithoutActivities', {}, {
			get: {
				method: 'POST',
			},
		})

		var getActivityCalendarReviewedRejectById = $resource(SERVICE_URL_CONSTANT.rosario + '/calendar/getActivityCalendarReviewedRejectById', {}, {
			getList: {
				method: 'POST',
			},
		})

		// MESSEGES SERVICES
		var getMessages = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getNotificationToShowByUser', {}, {
			get: {
				method: 'POST',
			},
		})

		var getMessagesNotification = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getMessagesNotification', {}, {
			get: {
				method: 'POST',
			},
		})

		var updateReadingMessages = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/updateNotificationReadByUser', {}, {
			update: {
				method: 'POST',
			},
		})

		// END PLANNING SERVICE
		var getSummanyProgress = $resource(SERVICE_URL_CONSTANT.rosario + '/general/getSummaryProgressBySubmodule', {}, {
			post: {
				method: 'POST',
			},
		})

		var endPlanning = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/updateWorkplanTeacherWithStage', {}, {
			post: {
				method: 'POST',
			},
		})

		var getItemRequiredTeaching = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getItemRequiredTeaching', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getItemRequiredOtherActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getItemRequiredOtherActivities', {}, {
			getList: {
				method: 'POST',
			},
		})

		// ENDSTAGES SERVICE
		var endStages = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/updateWorkplanTeacherWithStage', {}, {
			update: {
				method: 'POST',
			},
		})

		var getReprovedActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getReprovedActivities', {}, {
			get: {
				method: 'POST',
			},
		})

		var getAsignaturesAssignedReviewedReject = $resource(SERVICE_URL_CONSTANT.rosario + '/subject/getAsignaturesAssignedReviewedReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		var updateFeedbackActivate = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/updateFeedbackActivate', {}, {
			update: {
				method: 'POST',
			},
		})

		var addNotificationsTransactions = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsTransactions', {}, {
			add: {
				method: 'POST',
			},
		})

		var addNotificationsTransactionsToAdmin = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsTransactionsToAdmin', {}, {
			add: {
				method: 'POST',
			},
		})

		// REVIEW SERVICE

		var getDelegationCharges = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDelegationCharges', {}, {
			getList: {
				method: 'POST',
			},
		})

		var addActivityPlanningAcademic = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addActivityPlanningAcademic', {}, {
			save: {
				method: 'POST',
			},
		})

		var getActivityPlanningAcademic = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getActivityPlanningAcademic', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getDataRolesList = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataRolesList', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getActivityDetailAcademic = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getActivityDetailAcademic', {}, {
			getList: {
				method: 'POST',
			},
		})

		var addRol = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addRol', {}, {
			save: {
				method: 'POST',
			},
		})
		var updateAssignatureWorkPlan = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/updateAssignatureWorkPlan', {}, {
			post: {
				method: 'POST',
			},
		})

		var deleteParticipation = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/disableActivity', {}, {
			delete: {
				method: 'POST',
			},
		})

		var getDataPhdList = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataPhdList', {}, {
			getList: {
				method: 'POST',
			},
		})

		var addPhd = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addPhd', {}, {
			save: {
				method: 'POST',
			},
		})

		var disableActivityTeachingStaff = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/disableActivityTeachingStaff', {}, {
			delete: {
				method: 'POST',
			},
		})

		var getInstitutionCountry = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getInstitutionCountry', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getDataFormActivityTeaching = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormActivityTeaching', {}, {
			get: {
				method: 'GET',
			},
		})

		var getWorkPlansInReview = $resource(SERVICE_URL_CONSTANT.rosario + '/workplan/getWorkPlansInReview', {}, {
			get: {
				method: 'GET',
			},
		})

		var getDataCoursesList = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataCoursesList', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getCoursesIntern = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getCoursesIntern', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getCoursesInternDetail = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getCoursesInternDetail', {}, {
			getList: {
				method: 'POST',
			},
		})

		var addCourseExtern = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addCourseExtern', {}, {
			save: {
				method: 'POST',
			},
		})

		var getOtherActivitiesReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getOtherActivitiesReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		// Body Consolidation Profesoral Sevices
		var getDataFormCommunities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormCommunities', {}, {
			get: {
				method: 'POST',
			},
		})

		var deleteDataFormCommunities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/disableActivityTeachingStaff', {}, {
			delete: {
				method: 'POST',
			},
		})

		// RESEARCH
		var getListProjectsFormulated = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListProjectsFormulated', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getListProjectsFormulatedReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListProjectsFormulatedReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		var disableProject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/disableProject', {}, {
			delete: {
				method: 'POST',
			},
		})

		var addProjectFormulated = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addProjectFormulated', {}, {
			save: {
				method: 'POST',
			},
		})

		var getProjectsFormulated = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getProjectsFormulated', {}, {
			get: {
				method: 'POST',
			},
		})

		var getWorkPlansInApproved = $resource(SERVICE_URL_CONSTANT.rosario + '/workplan/getWorkPlansInApproved', {}, {
			get: {
				method: 'GET',
			},
		})

		var getListState = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListState', {}, {
			get: {
				method: 'POST',
			},
		})

		var getDataFormProjects = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormProjects', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getDataFormProjectsReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormProjectsReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getProjectByActivityId = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getProjectByActivityId', {}, {
			get: {
				method: 'POST',
			},
		})

		var addActivityExecution = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addActivityExecution', {}, {
			get: {
				method: 'POST',
			},
		})

		var addActivityProject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addActivityProject', {}, {
			save: {
				method: 'POST',
			},
		})

		var getFeedbackReviewedReject = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getFeedbackReviewedReject', {}, {
			get: {
				method: 'POST',
			},
		})

		var getFeedbackReviewedRejectGeneral = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getFeedbackReviewedRejectGeneral', {}, {
			get: {
				method: 'POST',
			},
		})

		var getDataFormProduct = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormProduct', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getDataFormProductReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormProductReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getDelegationChargesReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDelegationChargesReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getProductByActivityId = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getProductByActivityId', {}, {
			get: {
				method: 'POST',
			},
		})

		var disableProductActivyId = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/disableProductActivyId', {}, {
			get: {
				method: 'POST',
			},
		})

		var getDataFormCommitteeReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormCommitteeReject', {}, {
			get: {
				method: 'POST',
			},
		})

		var addActivityProduct = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addActivityProduct', {}, {
			save: {
				method: 'POST',
			},
		})

		// EXTENSION
		var getListFormulatedExtensionProjects = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListFormulatedExtensionProjects', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getListFormulatedExtensionProjectsReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListFormulatedExtensionProjectsReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getOtherActivityItemAMReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getOtherActivityItemAMReject', {}, {
			get: {
				method: 'POST',
			},
		})

		var getFormulatedExtensionProjectsById = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getFormulatedExtensionProjectsById', {}, {
			get: {
				method: 'POST',
			},
		})

		var getListSpacesCollaboration = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListSpacesCollaboration', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getListSpacesCollaborationReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListSpacesCollaborationReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		var addProjectsExtensionFormulated = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addProjectsExtensionFormulated', {}, {
			save: {
				method: 'POST',
			},
		})

		var getDataRolesListReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataRolesListReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		var disableActivityResearch = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/disableActivityResearch', {}, {
			delete: {
				method: 'POST',
			},
		})

		var getExtensionProjectsById = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getExtensionProjectsById', {}, {
			get: {
				method: 'POST',
			},
		})

		var getDataPhdListReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataPhdListReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getDataFormAdviceConsultancy = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormAdviceConsultancy', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getDataFormAdviceConsultancyReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormAdviceConsultancyReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getDataFormCommunitiesReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormCommunitiesReject', {}, {
			get: {
				method: 'POST',
			},
		})

		var addAdviceConsultancy = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addAdviceConsultancy', {}, {
			save: {
				method: 'POST',
			},
		})
		var getDataCoursesListReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataCoursesListReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getDataFormProjectsExtension = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormProjectsExtension', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getDataFormProjectsExtensionReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormProjectsExtensionReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getProjectExtensionByActivityId = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getProjectExtensionByActivityId', {}, {
			get: {
				method: 'POST',
			},
		})

		var getProjectsCrossById = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getProjectsCrossById', {}, {
			get: {
				method: 'POST',
			},
		})

		var setDumpInformation = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/setDumpInformation', {}, {
			post: {
				method: 'POST',
			},
		})

		var summary = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:workplanId/:teacherId', {}, {
			getDataGrid: {
				method: 'GET',
				params: {
					type : 'workplan',
					route: 'getSubmodulesRevision',
				},
			},
			getTeacherData: {
				method: 'GET',
				params: {
					type : 'teacher',
					route: 'getSummaryAprovedByTeacher',
				},
			},
			checkReviewerApprover: {
				method: 'POST',
				params: {
					type : 'workplan',
					route: 'checkReviewerApprover',
				},
			},
			approvalAll: {
				method: 'POST',
				params: {
					type : 'workplan',
					route: 'updateWorkPlanTeacher',
				},
			},
			approvalAllEvaluation: {
				method: 'POST',
				params: {
					type : 'workplan',
					route: 'updateWorkPlanTeacherForEvaluation',
				},
			},

		})

		var addSpaceCollaboration = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addSpaceCollaboration', {}, {
			save: {
				method: 'POST',
			},
		})

		var addActivityProjectExtension = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addActivityProjectExtension', {}, {
			save: {
				method: 'POST',
			},
		})

		var getSpacesCollaboration = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getSpacesCollaboration', {}, {
			get: {
				method: 'POST',
			},
		})

		var getAdviceConsultancyById = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getAdviceConsultancyById', {}, {
			get: {
				method: 'POST',
			},
		})

		var getListResearchTraining = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListResearchTraining', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getListResearchTrainingReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListResearchTrainingReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getDataFormShortCourses = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormShortCourses', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getDataFormShortCoursesReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormShortCoursesReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		var addResearchTraining = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addResearchTraining', {}, {
			save: {
				method: 'POST',
			},
		})

		var addShortCourses = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addShortCourses', {}, {
			save: {
				method: 'POST',
			},
		})

		var getResearchTrainingByActivityId = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getResearchTrainingByActivityId', {}, {
			get: {
				method: 'POST',
			},
		})

		var getShortCoursesById = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getShortCoursesById', {}, {
			get: {
				method: 'POST',
			},
		})

		var getDataFormTransferResults = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormTransferResults', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getDataFormTransferResultsReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormTransferResultsReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getListVisibilityActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListVisibilityActivities', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getListVisibilityActivitiesReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListVisibilityActivitiesReject', {}, {
			getList: {
				method: 'POST',
			},
		})

		var addTransferResult = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addTransferResult', {}, {
			save: {
				method: 'POST',
			},
		})

		var getVisibilityActivitiesById = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getVisibilityActivitiesById', {}, {
			get: {
				method: 'POST',
			},
		})

		var addVisibilityActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addVisibilityActivities', {}, {
			save: {
				method: 'POST',
			},
		})

		var getTransferResultsByActivityId = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getTransferResultsByActivityId', {}, {
			get: {
				method: 'POST',
			},
		})

		var getCriteriaCategoryDetail = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/getCriteriaCategoryDetail', {}, {
			get: {
				method: 'POST',
			},
		})

		const getWorkplanEvaluationCriteriaDetail = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/getWorkplanEvaluationCriteriaDetail', {}, {
			get: {
				method: 'POST',
			},
		})

		var getHistoryActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getHistoryActivities/:id', {}, {
			get: {
				method: 'GET',
			},
		})

		var postUptHistoryActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/postUptHistoryActivities', {}, {
			get: {
				method: 'POST',
			},
		})

		var getItemRequiredExecution = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getItemRequiredExecution', {}, {
			getList: {
				method: 'POST',
			},
		})

		var getEntries = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route', {}, {
			entries: {
				method: 'POST',
				params: {
					type : 'strategic_tracking',
					route: 'getActivitiesEntries',
				},
			},
		})

		var addSpecialSituationTeacher = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/addSpecialSituationTeacher', {}, {
			set: {
				method: 'POST',
			},
		})

		var listUserNotify = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/listUserNotify', {}, {
			set: {
				method: 'POST',
			},
		})

		var setPlanningWorkplanByTeacher = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/setPlanningWorkplanByTeacher', {}, {
			set: {
				method: 'POST',
			},
		})

		var getRecordTeacher = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getRecordTeacher', {}, {
			get: {
				method: 'POST',
			},
		})

		var getActivitiesNotReviewed = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getActivitiesNotReviewed', {}, {
			get: {
				method: 'POST',
			},
		})

		var updateIsNotification = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/updateIsNotification', {}, {
			post: {
				method: 'POST',
			},
		})

		var getListProjectsCross = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListProjectsCross', {}, {
			post: {
				method: 'POST',
			},
		})

		// SERVICES INJECTION
		return {
			addOtherActivityAM                   : addOtherActivityAM,
			getOtherActivityItemAM               : getOtherActivityItemAM,
			disableActivity                      : disableActivity,
			getEntries                           : getEntries,
			// OTHER
			getActivities                        : getActivities,
			getActivitiesCombo                   : getActivitiesCombo,
			addActivityItem                      : addActivityItem,
			addSchedule                          : addSchedule,
			getActivityItem                      : getActivityItem,
			getSchedules                         : getSchedules,
			getMessages                          : getMessages,
			getMessagesNotification              : getMessagesNotification,
			getDataForSchedule                   : getDataForSchedule,
			getScheduleById                      : getScheduleById,
			updateActivityItem                   : updateActivityItem,
			updateSchedule                       : updateSchedule,
			updateReadingMessages                : updateReadingMessages,
			deleteActivityItem                   : deleteActivityItem,
			getAsignaturesAssigned               : getAsignaturesAssigned,
			getElementsRightBar                  : getElementsRightBar,
			disableSchedule                      : disableSchedule,
			getActivityPlanningTeacher           : getActivityPlanningTeacher,
			addActivityPlanningTeacher           : addActivityPlanningTeacher,
			getDetailAsignaturePlanning          : getDetailAsignaturePlanning,
			getAssignatureWithoutActivities      : getAssignatureWithoutActivities,
			getPreviusPlanning                   : getPreviusPlanning,
			getDelegationCharges                 : getDelegationCharges,
			addActivityPlanningAcademic          : addActivityPlanningAcademic,
			getActivityPlanningAcademic          : getActivityPlanningAcademic,
			getDataRolesList                     : getDataRolesList,
			getActivityDetailAcademic            : getActivityDetailAcademic,
			addRol                               : addRol,
			getDataPhdList                       : getDataPhdList,
			addPhd                               : addPhd,
			disableActivityTeachingStaff         : disableActivityTeachingStaff,
			getInstitutionCountry                : getInstitutionCountry,
			getDataCoursesList                   : getDataCoursesList,
			getCoursesIntern                     : getCoursesIntern,
			getCoursesInternDetail               : getCoursesInternDetail,
			addCourseExtern                      : addCourseExtern,
			getPeriodicity                       : getPeriodicity,
			getActivityCalendarReviewedRejectById: getActivityCalendarReviewedRejectById,
			getOtherActivitiesReject             : getOtherActivitiesReject,
			// END PLANNING
			getSummanyProgress                   : getSummanyProgress,
			endPlanning                          : endPlanning,
			listUserNotify                       : listUserNotify,
			// ENDSTAGES
			endStages                            : endStages,
			getReprovedActivities                : getReprovedActivities,
			getAsignaturesAssignedReviewedReject : getAsignaturesAssignedReviewedReject,
			updateFeedbackActivate               : updateFeedbackActivate,
			addSpecialSituationTeacher           : addSpecialSituationTeacher,
			//
			getWorkplanByEvaluatorAndStage       : getWorkplanByEvaluatorAndStage,
			deleteParticipation                  : deleteParticipation,
			getDataFormCommittee                 : getDataFormCommittee,
			getListOtherActivityItemAM           : getListOtherActivityItemAM,
			addActivityCommittee                 : addActivityCommittee,
			updateAssignatureWorkPlan            : updateAssignatureWorkPlan,
			getActivityCommitteeByActivity       : getActivityCommitteeByActivity,
			getWorkPlansInReview                 : getWorkPlansInReview,
			getItemRequiredTeaching              : getItemRequiredTeaching,
			getItemRequiredOtherActivities       : getItemRequiredOtherActivities,
			// Body Consolidation Profesoral
			getDataFormCommunities               : getDataFormCommunities,
			deleteDataFormCommunities            : deleteDataFormCommunities,
			addActivityCommunity                 : addActivityCommunity,
			getActivityDetailTeachingStaff       : getActivityDetailTeachingStaff,
			getDataFormActivityTeaching          : getDataFormActivityTeaching,
			getWorkPlansInApproved               : getWorkPlansInApproved,
			getListState                         : getListState,
			addActivityExecution                 : addActivityExecution,

			// RESEARCH
			getListProjectsFormulated               : getListProjectsFormulated,
			disableProject                          : disableProject,
			addProjectFormulated                    : addProjectFormulated,
			getProjectsFormulated                   : getProjectsFormulated,
			getDataFormProjects                     : getDataFormProjects,
			getProjectByActivityId                  : getProjectByActivityId,
			addActivityProject                      : addActivityProject,
			getDataFormProduct                      : getDataFormProduct,
			getProductByActivityId                  : getProductByActivityId,
			disableProductActivyId                  : disableProductActivyId,
			addActivityProduct                      : addActivityProduct,
			getListSpacesCollaboration              : getListSpacesCollaboration,
			disableActivityResearch                 : disableActivityResearch,
			addSpaceCollaboration                   : addSpaceCollaboration,
			getSpacesCollaboration                  : getSpacesCollaboration,
			getListResearchTraining                 : getListResearchTraining,
			addResearchTraining                     : addResearchTraining,
			getResearchTrainingByActivityId         : getResearchTrainingByActivityId,
			getDataFormTransferResults              : getDataFormTransferResults,
			addTransferResult                       : addTransferResult,
			getTransferResultsByActivityId          : getTransferResultsByActivityId,
			getListSpacesCollaborationReject        : getListSpacesCollaborationReject,
			getDataFormProductReject                : getDataFormProductReject,
			getDataFormProjectsReject               : getDataFormProjectsReject,
			getListProjectsFormulatedReject         : getListProjectsFormulatedReject,
			getDataFormTransferResultsReject        : getDataFormTransferResultsReject,
			getListResearchTrainingReject           : getListResearchTrainingReject,
			getDataFormAdviceConsultancyReject      : getDataFormAdviceConsultancyReject,
			updateIsNotification                    : updateIsNotification,
			getListProjectsCross                    : getListProjectsCross,
			//
			getFeedbackReviewedReject               : getFeedbackReviewedReject,
			getFeedbackReviewedRejectGeneral        : getFeedbackReviewedRejectGeneral,
			// EXTENSION
			getListFormulatedExtensionProjects      : getListFormulatedExtensionProjects,
			getFormulatedExtensionProjectsById      : getFormulatedExtensionProjectsById,
			addProjectsExtensionFormulated          : addProjectsExtensionFormulated,
			getExtensionProjectsById                : getExtensionProjectsById,
			getDataFormAdviceConsultancy            : getDataFormAdviceConsultancy,
			addAdviceConsultancy                    : addAdviceConsultancy,
			getDataFormProjectsExtension            : getDataFormProjectsExtension,
			getProjectExtensionByActivityId         : getProjectExtensionByActivityId,
			addActivityProjectExtension             : addActivityProjectExtension,
			getAdviceConsultancyById                : getAdviceConsultancyById,
			getDataFormShortCourses                 : getDataFormShortCourses,
			addShortCourses                         : addShortCourses,
			getShortCoursesById                     : getShortCoursesById,
			getListVisibilityActivities             : getListVisibilityActivities,
			getVisibilityActivitiesById             : getVisibilityActivitiesById,
			addVisibilityActivities                 : addVisibilityActivities,
			getDelegationChargesReject              : getDelegationChargesReject,
			getDataFormCommitteeReject              : getDataFormCommitteeReject,
			getOtherActivityItemAMReject            : getOtherActivityItemAMReject,
			getDataRolesListReject                  : getDataRolesListReject,
			getDataPhdListReject                    : getDataPhdListReject,
			getDataFormCommunitiesReject            : getDataFormCommunitiesReject,
			getDataCoursesListReject                : getDataCoursesListReject,
			setDumpInformation                      : setDumpInformation,
			summary                                 : summary,
			getSchedulesReject                      : getSchedulesReject,
			getCriteriaCategoryDetail               : getCriteriaCategoryDetail,
			getWorkplanEvaluationCriteriaDetail,
			getHistoryActivities                    : getHistoryActivities,
			postUptHistoryActivities                : postUptHistoryActivities,
			getItemRequiredExecution                : getItemRequiredExecution,
			getDataFormProjectsExtensionReject      : getDataFormProjectsExtensionReject,
			getListFormulatedExtensionProjectsReject: getListFormulatedExtensionProjectsReject,
			getDataFormShortCoursesReject           : getDataFormShortCoursesReject,
			getListVisibilityActivitiesReject       : getListVisibilityActivitiesReject,
			addNotificationsTransactions            : addNotificationsTransactions,
			getProjectsCrossById                    : getProjectsCrossById,
			addNotificationsTransactionsToAdmin     : addNotificationsTransactionsToAdmin,
			setPlanningWorkplanByTeacher            : setPlanningWorkplanByTeacher,
			getRecordTeacher                        : getRecordTeacher,
			getActivitiesNotReviewed                : getActivitiesNotReviewed,
			getIndicatorBySubmodule                 : getIndicatorBySubmodule,
		}
	}

}
WorkPlanSrv.$inject = [ '$resource', 'SERVICE_URL_CONSTANT', 'GlobalConfig' ]
export default angular.module('services.WorkPlanSrv', []).service('WorkPlanSrv', WorkPlanSrv).name



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/workplanSrv.js